/*=========================================================================================
  File Name: moduleNotifyGetters.js
  Description: Notify Module Getters
==========================================================================================*/


export default {
    getNotify: state => state.notify,
}
